import service from './index'

const prefix = '/common-uam';

//e-signauture password
export const judgeUserHasSignaturePassword = () => service.get(`${prefix}/users/e-signature/exist`);

export const createElectronicSignaturePassword = (params: {}) => service.post(`${prefix}/users/e-signature`, params);

export const updateElectronicSignaturePassword = (params: {}) => service.put(`${prefix}/users/e-signature`, params);

// System Settings

export const getTenantSettings = (tenantId: string) =>
  service.get(`${prefix}/system-settings/tenant-settings`, {
    params: { tenantId },
  });

export const getModuleResourceList = (domainId: string) => service.get(`${prefix}/tm/subscription/modules?domainId=${domainId}`);

  export const getDomainList = () => service.get(`${prefix}/tm/domains`);

  export const apiGetESignSetting = (id:string) => service.get(`/freyr-tm/tmSubscription/eSignSetting?tenantId=${id}&moduleName=RTQ`);
  
  export const fetchFeatureFlag = (id:string):Promise<API.DataResponse<API.FeatureFlagsData>> => service.get(`/freyr-tm/tmTenant/feature-flags?tenantId=${id}&moduleId=8`);
export const getSystemFeatureFlag = (params: Record<string, unknown>) =>
  service.get(`/freyr-tm/tmTenant/feature-flags`, { params });
